module.exports = __webpack_public_path__ + "img/finances-bg-ueex.53047ae7.png";